(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race-handler.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race-handler.js');
'use strict';

const createRaceHandler = svs.components.sport.raceHandler.race.createRaceHandler;
let instance;
const raceHandler = () => {
  if (!instance) {
    instance = createRaceHandler();
  }
  return instance;
};
setGlobal('svs.components.sport.raceHandler.raceHandler', raceHandler);

 })(window);